"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
function getInboxRuleMessageTypeOptions() {
    return [
        { value: 'ApprovalRequest', text: owa_options_strings_1.default.options_inboxRules_requestForApproval },
        { value: 'AutomaticForward', text: owa_options_strings_1.default.options_inboxRules_automaticallyForwarded },
        { value: 'AutomaticReply', text: owa_options_strings_1.default.options_inboxRules_automaticReply },
        { value: 'Calendaring', text: owa_options_strings_1.default.options_inboxRules_invitation },
        { value: 'CalendaringResponse', text: owa_options_strings_1.default.options_inboxRules_eventResponse },
        { value: 'Encrypted', text: owa_options_strings_1.default.options_inboxRules_encrypted },
        { value: 'NonDeliveryReport', text: owa_options_strings_1.default.options_inboxRules_nonDeliveryReport },
        { value: 'PermissionControlled', text: owa_options_strings_1.default.options_inboxRules_permissionControlled },
        { value: 'ReadReceipt', text: owa_options_strings_1.default.options_inboxRules_readReceipt },
        { value: 'Signed', text: owa_options_strings_1.default.options_inboxRules_signed },
        { value: 'Voicemail', text: owa_options_strings_1.default.options_inboxRules_voiceMail },
    ];
}
exports.default = getInboxRuleMessageTypeOptions;
//# sourceMappingURL=getInboxRuleMessageTypeOptions.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/helpers/getInboxRuleMessageTypeOptions.js
// module id = 5200
// module chunks = 2